import React, { Component } from 'react';
import { Pagination } from 'react-bootstrap';

export function savedTitleSearch(key) {
    try { return window.localStorage.getItem('orbis.settings.titleSearch.' + key) || ''; }
    catch (_) { return ''; }
}

export default class SearchableSettingsPage extends Component {
    requestId = 0;
    componentWillUnmount() { this.requestId += 1; }

    filteredRows = () => {
        const query = this.state.searchText.toLocaleLowerCase();
        return this.state.allRows.filter(row =>
            String(row[this.searchConfig.field] || '').toLocaleLowerCase().includes(query));
    }

    pageRows = () => {
        const start = (this.state.pageId - 1) * this.state.pageSize;
        return this.filteredRows().slice(start, start + this.state.pageSize);
    }

    reloadRows = () => {
        const requestId = ++this.requestId;
        return fetch(this.searchConfig.endpoint, {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' },
            body: 'startIndex=-1&pageSize=0'
        }).then(response => {
            if (response.ok === false) throw new Error('Unable to load titles');
            return response.json();
        }).then(allRows => {
            if (requestId !== this.requestId) return;
            if (!Array.isArray(allRows)) throw new Error('Unable to load titles');
            this.setState(state => {
                const query = state.searchText.toLocaleLowerCase();
                const count = allRows.filter(row => String(row[this.searchConfig.field] || '')
                    .toLocaleLowerCase().includes(query)).length;
                const pageId = Math.min(state.pageId, Math.max(1, Math.ceil(count / state.pageSize)));
                return { allRows, pageId, startIndex: (pageId - 1) * state.pageSize, searchError: '' };
            });
        }).catch(() => {
            if (requestId === this.requestId) this.setState({ searchError: 'Unable to load titles. Please try again.' });
        });
    }

    handleTitleSearch = event => {
        const searchText = event.target.value;
        try { window.localStorage.setItem('orbis.settings.titleSearch.' + this.searchConfig.key, searchText); }
        catch (_) { /* Filtering still works if browser storage is unavailable. */ }
        this.setState({ searchText, pageId: 1, startIndex: 0 });
    }

    renderTitleSearch = () => (
        <div style={{ margin: '1rem auto', maxWidth: '32rem', padding: '0 1rem' }}>
            <label htmlFor={this.searchConfig.key + '-title-search'}>Search by title</label>
            <input id={this.searchConfig.key + '-title-search'} type="search" className="form-control"
                placeholder="Type part of a title…" value={this.state.searchText}
                onChange={this.handleTitleSearch} />
            <div role="status" aria-live="polite" style={{ marginTop: '.5rem' }}>
                {this.filteredRows().length} matching {this.filteredRows().length === 1 ? 'item' : 'items'}
            </div>
            {this.state.searchError && <div role="alert">{this.state.searchError} <button onClick={this.reloadRows}>Retry</button></div>}
        </div>
    )

    renderPagination = () => {
        const count = this.filteredRows().length;
        const pages = Math.ceil(count / this.state.pageSize);
        return <Pagination>{Array.from({ length: pages }, (_, index) => {
            const pageId = index + 1;
            return <Pagination.Item className="pageEvents" key={pageId} active={pageId === this.state.pageId}
                onClick={() => this.setState({ pageId, startIndex: index * this.state.pageSize })}>
                {pageId}
            </Pagination.Item>;
        })}</Pagination>;
    }
}
